import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './pedidoForm';
import FormatUtils from '../common/formatUtils/FormatUtils';
import Aguardando from '../common/template/aguardando';
import pdfAdd from '../assets/images/icone_add_pdf.png';

import { 
	alterarCarregamentoBase
} from './pedidoActions';
import { getLista as getListaPedidoPrazo } from '../pedidoPrazo/pedidoPrazoActions';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import consts from '../consts';
import Camera from '../common/camera/camera';
import { setError } from '../common/toast/toast';

class PedidoBaseVisualizacao extends Component {

	state = {
		linhaSelecionada: null,
		scrollY: -1
	}

    componentWillMount() {
		this.props.getListaPedidoPrazo();
	}
	
    render() {

		const registro = this.props.registro;

        return (
            <div>
                <Content>
					
					<Aguardando aguardando={this.props.aguardando} />

					{this.eventoComponenteNumerico()}

					<ContentCard key={registro.id} style={{ backgroundColor: '#ffffff' }}>
						<ContentCardHeader>
							<Row>
								<Grid cols='6 6 6 6'>
									<strong>Giro:</strong>
								</Grid>
								<Grid cols='6 6 6 6' style={{ textAlign: 'right' }}>
									<strong>Data/Hora Carga:</strong>
								</Grid>
							</Row>
							<Row>
								<Grid cols='6 6 6 6'>
									{registro.giro}
								</Grid>
								<Grid cols='6 6 6 6' style={{ textAlign: 'right' }}>
									{DateFormat.formatarDataHoraSqlParaTela(registro.datahora_entrega || registro.datahora_logistica)}
								</Grid>
							</Row>
							<Row>
								<Grid cols='6 6 6 6'>
									<strong>Placa:</strong>
								</Grid>
								<Grid cols='6 6 6 6' style={{ textAlign: 'right' }}>
									<strong>Vendedor:</strong>
								</Grid>
							</Row>
							<Row>
								<Grid cols='6 6 6 6'>
									{registro.placa_veiculo}
								</Grid>
								<Grid cols='6 6 6 6' style={{ textAlign: 'right' }}>
									{registro.nome_usuario_inclusao}
								</Grid>
							</Row>

							<Row>
								<Grid cols='6 6 6 6'>
									<strong>Início do Carregamento:</strong>
								</Grid>
								<Grid cols='6 6 6 6' style={{ textAlign: 'right' }}>
									<strong>Fim do Carregamento:</strong>
								</Grid>
							</Row>
							<Row>
								<Grid cols='6 6 6 6'>
									{DateFormat.formatarDataHoraSqlParaTela(registro.datahora_inicio_carregamento)}
								</Grid>
								<Grid cols='6 6 6 6' style={{ textAlign: 'right' }}>
									{DateFormat.formatarDataHoraSqlParaTela(registro.datahora_fim_carregamento)}
								</Grid>
							</Row>
								
							{registro.datahora_inicio_carregamento &&
							<Row>
								{this.componenteImagem(
									'Foto do Calço:',
									registro.carregamento_imagem_calco || [],
									(arquivos) => {
										this.props.alterarCarregamentoBase({
											...registro,
											carregamento_imagem_calco: arquivos
										});
									}
								)}
							</Row>}
							{registro.datahora_inicio_carregamento &&
							<Row>
								{this.componenteImagem(
									'Foto do Aterramento:',
									registro.carregamento_imagem_terra || [],
									(arquivos) => {
										this.props.alterarCarregamentoBase({
											...registro,
											carregamento_imagem_terra: arquivos
										});
									}
								)}
							</Row>}
											
							<Row>
								{(registro.itens || []).map((pedidoItem, i) => {

									const comprovantes = pedidoItem.imagem_nfe && pedidoItem.imagem_checklist;

									return (								
										<Grid cols='12 12 12 12' key={pedidoItem.id} style={{ marginTop: 4, marginBottom: 0}}>
											<div class='card' style={{ backgroundColor: comprovantes ? '#026625' : '#194682' }}>
												<div class='card-header' style={{ padding: 4 }}>
													<p style={{ fontWeight: 'bold', color: '#ffffff' }} class='card-title'>Entrega {i + 1}</p>
												</div>
												<div class='card-body' style={{ padding: 4, backgroundColor: comprovantes ? '#c1e3cd' : '#cbdef7' }}>
													<p style={{ padding: 0, margin: 0, color: comprovantes ? '#026625' : '#183b6b' }}><b>Cliente:</b> {pedidoItem.nome_cliente}</p>
													<p style={{ padding: 0, margin: 0, color: comprovantes ? '#026625' : '#183b6b' }}><b>Endereço:</b> {pedidoItem.nome_endereco}</p>
													<p style={{ padding: 0, margin: 0, color: comprovantes ? '#026625' : '#183b6b' }}><b>Produto:</b> {pedidoItem.nome_produto}</p>
													<p style={{ padding: 0, margin: 0, color: comprovantes ? '#026625' : '#183b6b' }}><b>Quantidade:</b> {FormatUtils.formatarValorTela(pedidoItem.quantidade, 2)}</p>
													{registro.datahora_inicio_carregamento &&
													<>
														{(registro.carregamento_imagem_nf || []).filter(arquivo => arquivo.id_pedido_item == pedidoItem.id).length > 0 &&
														<Row>
															{this.componenteImagem(
																'Foto da Nota Fiscal:',
																(registro.carregamento_imagem_nf || []).filter(arquivo => arquivo.id_pedido_item == pedidoItem.id),
																(arquivos) => {
																	let arquivosAux = (registro.carregamento_imagem_nf || []).filter(arquivo => arquivo.id_pedido_item != pedidoItem.id).map(arquivo => arquivo);
																	
																	arquivos.forEach(arquivo => {
																		arquivosAux.push({
																			...arquivo,
																			id_pedido_item: pedidoItem.id
																		});
																	});

																	this.props.alterarCarregamentoBase({
																		...registro,
																		carregamento_imagem_nf: arquivosAux
																	});
																}
															)}
														</Row>}

														{(registro.carregamento_numero_nf || []).filter(arquivo => arquivo.id_pedido_item == pedidoItem.id).length > 0 &&
														<>
														{(false && this.props.usuarioCarregado && (this.props.usuarioCarregado.acesso_logistica) 
															&& (this.props.usuarioCarregado && this.props.usuarioCarregado.id_perfil != 27)) ? ( //Manutenção + Frota + Base
															<Row>
																{this.componenteNumericoAlteracao(
																	`Número da Nota Fiscal:`,
																	(registro.carregamento_numero_nf || []).filter(registro => registro.id_pedido_item == pedidoItem.id)[0],
																	(valor) => {
																		let itensAux = (registro.carregamento_numero_nf || []).filter(registro => registro.id_pedido_item != pedidoItem.id).map(registro => registro);
																		
																		itensAux.push({
																			id_pedido_item: pedidoItem.id,
																			valor: valor
																		});

																		this.props.alterarCarregamentoBase({
																			...registro,
																			carregamento_numero_nf: itensAux
																		});
																	},
																	0 //Casas Decimais
																)}
															</Row>
														) : (
															<Row>
																{this.componenteNumerico(
																	`Número da Nota Fiscal:`,
																	(registro.carregamento_numero_nf || []).filter(registro => registro.id_pedido_item == pedidoItem.id)[0],
																	(valor) => {},
																	0 //Casas Decimais
																)}
															</Row>
														)}
														</>}

														{(pedidoItem.compartimentos || []).map(comp => 
															<Row key={comp}>
																{this.componenteImagem(
																	`Foto da Boca ${comp || '0'}:`,
																	(registro.carregamento_imagem_boca || []).filter(arquivo => arquivo.id_pedido_item == pedidoItem.id && arquivo.compartimento == comp),
																	(arquivos) => {
																		let arquivosAux = (registro.carregamento_imagem_boca || []).filter(arquivo => arquivo.id_pedido_item != pedidoItem.id || arquivo.compartimento != comp).map(arquivo => arquivo);
																		
																		arquivos.forEach(arquivo => {
																			arquivosAux.push({
																				...arquivo,
																				id_pedido_item: pedidoItem.id,
																				compartimento: comp
																			});
																		});

																		this.props.alterarCarregamentoBase({
																			...registro,
																			carregamento_imagem_boca: arquivosAux
																		});
																	}
																)}
																	
																{this.componenteImagem(
																	`Foto do Lacre - Boca ${comp || '0'}:`,
																	(registro.carregamento_imagem_lacre || []).filter(arquivo => arquivo.id_pedido_item == pedidoItem.id && arquivo.compartimento == comp),
																	(arquivos) => {
																		let arquivosAux = (registro.carregamento_imagem_lacre || []).filter(arquivo => arquivo.id_pedido_item != pedidoItem.id || arquivo.compartimento != comp).map(arquivo => arquivo);
																		
																		arquivos.forEach(arquivo => {
																			arquivosAux.push({
																				...arquivo,
																				id_pedido_item: pedidoItem.id,
																				compartimento: comp
																			});
																		});

																		this.props.alterarCarregamentoBase({
																			...registro,
																			carregamento_imagem_lacre: arquivosAux
																		});
																	}
																)}
																	
																{this.componenteImagem(
																	`Foto do Dreno - Boca ${comp || '0'}:`,
																	(registro.carregamento_imagem_dreno || []).filter(arquivo => arquivo.id_pedido_item == pedidoItem.id && arquivo.compartimento == comp),
																	(arquivos) => {
																		let arquivosAux = (registro.carregamento_imagem_dreno || []).filter(arquivo => arquivo.id_pedido_item != pedidoItem.id || arquivo.compartimento != comp).map(arquivo => arquivo);
																		
																		arquivos.forEach(arquivo => {
																			arquivosAux.push({
																				...arquivo,
																				id_pedido_item: pedidoItem.id,
																				compartimento: comp
																			});
																		});

																		this.props.alterarCarregamentoBase({
																			...registro,
																			carregamento_imagem_dreno: arquivosAux
																		});
																	}
																)}
																															
																{this.componenteImagem(
																	`Foto da Seta - Boca ${comp || '0'}:`,
																	(registro.carregamento_imagem_seta || []).filter(arquivo => arquivo.id_pedido_item == pedidoItem.id && arquivo.compartimento == comp),
																	(arquivos) => {
																		let arquivosAux = (registro.carregamento_imagem_seta || []).filter(arquivo => arquivo.id_pedido_item != pedidoItem.id || arquivo.compartimento != comp).map(arquivo => arquivo);
																		
																		arquivos.forEach(arquivo => {
																			arquivosAux.push({
																				...arquivo,
																				id_pedido_item: pedidoItem.id,
																				compartimento: comp
																			});
																		});

																		this.props.alterarCarregamentoBase({
																			...registro,
																			carregamento_imagem_seta: arquivosAux
																		});
																	}
																)}

																{/*this.componenteImagem(
																		`Foto Medidor Volumétrico - Boca ${comp || '0'}:`,
																		(registro.carregamento_imagem_medidor || []).filter(arquivo => arquivo.id_pedido_item == pedidoItem.id && arquivo.compartimento == comp),
																		(arquivos) => {
																			let arquivosAux = (registro.carregamento_imagem_medidor || []).filter(arquivo => arquivo.id_pedido_item != pedidoItem.id || arquivo.compartimento != comp).map(arquivo => arquivo);
																			
																			arquivos.forEach(arquivo => {
																				arquivosAux.push({
																					...arquivo,
																					id_pedido_item: pedidoItem.id,
																					compartimento: comp
																				});
																			});

																			this.props.alterarCarregamentoBase({
																				...registro,
																				carregamento_imagem_medidor: arquivosAux
																			});
																		}
																	)*/}

																	{(this.props.usuarioCarregado && (this.props.usuarioCarregado.acesso_logistica) 
																		&& (this.props.usuarioCarregado && this.props.usuarioCarregado.id_perfil != 27)) ? ( //Manutenção + Frota + Base
																		this.componenteNumericoAlteracao(
																			`Quantidade Medidor Volumétrico - Boca ${comp || '0'}:`,
																			(registro.carregamento_quantidade_medidor || []).filter(registro => registro.id_pedido_item == pedidoItem.id && registro.compartimento == comp)[0],
																			(valor) => {
																				let itensAux = (registro.carregamento_quantidade_medidor || []).filter(registro => registro.id_pedido_item != pedidoItem.id || registro.compartimento != comp).map(registro => registro);
																				
																				itensAux.push({
																					id_pedido_item: pedidoItem.id,
																					compartimento: comp,
																					valor: valor
																				});

																				this.props.alterarCarregamentoBase({
																					...registro,
																					carregamento_quantidade_medidor: itensAux
																				});

																				setTimeout(() => {
																					this.props.eventoAtualizacao();
																				}, 2000);
																			},
																			0 //Casas Decimais
																		)
																	) : (
																		this.componenteNumerico(
																			`Quantidade Medidor Volumétrico - Boca ${comp || '0'}:`,
																			(registro.carregamento_quantidade_medidor || []).filter(registro => registro.id_pedido_item == pedidoItem.id && registro.compartimento == comp)[0],
																			0 //Casas Decimais
																		)
																	)}
															</Row>
														)}
													</>}
												</div>
											</div>
										</Grid>
									);
								})}
							</Row>
						</ContentCardHeader>
					</ContentCard>
					
                </Content>
            </div>
        )
    }

	componenteImagem(nome, arquivos, evento) {

		return (
			<Grid cols='12 12 12 12'>
				<Row style={{ paddingBottom: 8 }}>
					<Grid cols='12 12 12 12'>
						<label>{nome} <i class={(arquivos || []).length ? `fas fa-check-double` : 'fas fa-exclamation-triangle'} style={{ color: (arquivos || []).length ? '#00a13b' : '#ff0000' }}></i></label>
					</Grid>
					{(arquivos || []).map(arquivo => (
						<div key={arquivo.id} style={{ marginLeft: 8, display: 'flex', flexDirection: 'column' }}>
							<span class="btn btn-outline-primary fileinput-button dz-clickable"
								onClick={() => {
									window.open(`${consts.URL}/${arquivo.file}`, '_blank');
								}}>
								<img src={arquivo.arquivo_base64 ? arquivo.arquivo_base64 : (arquivo.file ? `${consts.URL}/${arquivo.file}` : pdfAdd)} style={{ height: 400 }} />
							</span>
						</div>
					))}						
				</Row>
			</Grid>
		);
	}

	componenteNumerico(nome, registro, casasDecimais) {

		return (
			<Grid cols='12 12 12 12'>
				<Row style={{ paddingBottom: 8 }}>
					<Grid cols='12 12 12 12'>
						<label>{nome} <i class={registro && parseFloat(registro.valor || 0) > 0.0  ? `fas fa-check-double` : 'fas fa-exclamation-triangle'} style={{ color: registro && parseFloat(registro.valor || 0) > 0.0 ? '#00a13b' : '#ff0000' }}></i></label>
					</Grid>
					<Grid cols='12 12 12 12'>
						<p>{registro ? FormatUtils.formatarValorTela(registro.valor, casasDecimais) : FormatUtils.formatarValorTela(0, casasDecimais)}</p>
					</Grid>
				</Row>
			</Grid>
		);
	}

	componenteNumericoAlteracao(nome, registro, evento, casasDecimais) {

		return (
			<Grid cols='12 12 12 12'>
				<Row style={{ paddingBottom: 8 }}>
					<Grid cols='12 12 12 12'>
						<label>{nome} <i class={registro && parseFloat(registro.valor || 0) > 0.0  ? `fas fa-check-double` : 'fas fa-exclamation-triangle'} style={{ color: registro && parseFloat(registro.valor || 0) > 0.0 ? '#00a13b' : '#ff0000' }}></i></label>
					</Grid>
					<button 
						type='button'
						class='btn btn-block btn-outline-dark btn-flat'
						style={{ maxWidth: 200 }}
						onClick={() => {
							this.setState({
								...this.state,
								casasComponenteNumerico: casasDecimais || 0,
								valorComponenteNumerico: registro ? FormatUtils.formatarValorTela(registro.valor, casasDecimais) : '',
								eventoComponenteNumerico: (result) => {
									evento(result);
									this.setState({
										...this.state,
										eventoComponenteNumerico: null
									});
								}
							});
						}}>
						{registro ? FormatUtils.formatarValorTela(registro.valor, casasDecimais) : FormatUtils.formatarValorTela(0, casasDecimais)}
					</button>
				</Row>
			</Grid>
		);
	}

	eventoComponenteNumerico() {
		if (!this.state.eventoComponenteNumerico) {
			return null;
		}

		return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-md'>
					<div class='modal-content'>
						<div class='modal-header'>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' 
								onClick={() => {
									this.setState({
										...this.state,
										eventoComponenteNumerico: null
									});
								}}>
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body'>
							<Row>
								<LabelAndInputNumber
									label='Informe' 
									placeholder='Informe'
									cols='12 12 12 12'
									casas={this.state.casasComponenteNumerico}
									value={this.state.valorComponenteNumerico}
									onChange={data => {
										this.setState({
											valorComponenteNumerico: data.target.value
										});
									}} />
							</Row>
						</div>
						<div class='modal-footer justify-content-between'>
							<button type='button' class='btn btn-default' data-dismiss='modal' style={{ visibility: 'hidden' }}>Close</button>
							<button type='button' class='btn btn-primary'
								onClick={() => {
									this.state.eventoComponenteNumerico(
										parseFloat(FormatUtils.formatarValorBanco(this.state.valorComponenteNumerico, this.state.casasComponenteNumerico))
									);
								}}>Salvar</button>
						</div>
					</div>
				</div>
			</div>
        );
	}
	
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.pedido.aguardando,
	modoTela: state.pedido.modoTela
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	alterarCarregamentoBase, getListaPedidoPrazo
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(PedidoBaseVisualizacao);
